// frontend/src/Components/SyncTo/helpers/sessionKey.js
// Phase 30 — D-07 sessionKey generator. Mirrors AddServicesPricing.jsx:36-39
// for consistency with existing repo precedent. Do NOT use the `uuid` npm pkg
// (already installed for other purposes) — the repo precedent is native + fallback.

export function makeSessionKey() {
  return (typeof crypto !== 'undefined' && crypto.randomUUID)
    ? crypto.randomUUID()
    : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 9)}`;
}
